import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '../../../firebase/config';

export const uploadImages = async (images) => {
  const uploadedImageUrls = await Promise.all(
    images.map(async (image) => {
      const imageRef = ref(storage, `reviews/${image.name}_${Date.now()}`);
      await uploadBytes(imageRef, image);
      return await getDownloadURL(imageRef);
    })
  );
  return uploadedImageUrls;
};